/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".itemList[_ngcontent-%COMP%]{max-height:25em;overflow-y:scroll}.itemList[_ngcontent-%COMP%]   .item-description[_ngcontent-%COMP%]{max-width:25em}.form-header[_ngcontent-%COMP%]   .company-logo[_ngcontent-%COMP%]{margin:0 auto;background-position:center;width:155px}"];
export { styles as styles };
